<template>
  <div
    class="modal fade show"
    id="exampleModalLive"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="idCalc"
    aria-modal="true"
    style="display: block;"
  >
    <div class="modal-dialog" :class="modalSize">
      <div class="modal-content">
        <div class="close-container">
          <Btn class="close" variant="link" data-dismiss="modal" aria-label="Close" @click="close">
            <Icon icon="close" :size="10" color="lambda" />
          </Btn>
        </div>
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <h5 class="modal-title" :id="idCalc">{{ title }}</h5>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer" v-if="!hideFooter">
            <slot name="footer">
              <Btn class="mr-2" variant="light" data-dismiss="modal" @click="close">
                {{ closeName }}
              </Btn>
              <Btn variant="primary" @click="confirm">{{ confirmName }}</Btn>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import i8n from "@/i18n";
import Icon from "@/components/display/icon/Icon";
import { uniqueId } from "lodash-es";

export default {
  name: "Modal",
  props: {
    title: String,
    dismissible: { type: Boolean, default: true },
    data: Object,
    id: String,
    closeName: { type: String, default: i8n.t("global.modal-close") },
    confirmName: { type: String, default: i8n.t("global.modal-confirm") },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
  },
  components: { Btn, Icon },
  setup(props, { emit }) {
    const idCalc = computed(() => {
      return props.id || uniqueId("input-");
    });

    onMounted(() => {
      document.body.classList.add("modal-open");
    });

    onUnmounted(() => {
      document.body.classList.remove("modal-open");
    });

    const close = () => {
      emit("close");
    };

    const confirm = () => {
      emit("confirm");
    };

    const sizeList = {
      small: "modal-sm",
      medium: "",
      large: "modal-lg",
    };
    const modalSize = computed(() => {
      return sizeList[props.size];
    });

    return {
      close,
      confirm,
      idCalc,
      modalSize,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
.modal-content {
  .close-container {
    display: flex;
    justify-content: flex-end;
    .close {
      opacity: 100;
      padding: 0.625rem;
      margin: 0.625rem 0.625rem 0 0;
    }
  }
  .modal-container {
    padding: 0 2.25rem 2.25rem 2.25rem;
    .modal-header {
      border: none;
      padding: 0 0 1.75rem 0;
      .modal-title {
        font-size: 1.125rem;
      }
    }
    .modal-body {
      font-size: 0.875rem;
      padding: 0;
    }
    .modal-footer {
      border: none;
      padding: 2rem 0 0 0;
      button {
        margin: 0;
      }
    }
  }
}
</style>
